import moment from 'moment'
import { LinkType, LinkTypeCode } from '@/dictionary/base.js'
import { StoreyType, StoreyShowType } from '@/dictionary/storey.js'
import { ReducationType } from '@/dictionary/goods.js'
import { EditMixin } from '@/mixins/EditMixin'
import merge from 'webpack-merge'
export const BaseMixin = {
  mixins: [EditMixin],
  components: {},
  data() {
    return {
      Enum_LinkType: LinkType,
      Enum_LinkTypeCode: LinkTypeCode,
      Enum_StoreyType: StoreyType,
      Enum_StoreyShowType: StoreyShowType,
      Enum_ReducationType: ReducationType,
      Format_DateTime: 'YYYY-MM-DD HH:mm:ss',
      Format_Date: 'YYYY-MM-DD'
    }
  },
  methods: {
    moment,
    // 初始化需要显示的Item，ShowNumber显示展示数量
    _initShowItems(storey) {
      let StoreyItemsDto = storey.OutStoreyItemsDtos
      if (StoreyItemsDto && storey.ShowNumber != 0) {
        const tempItems = []
        StoreyItemsDto.forEach((item) => {
          if (tempItems.length < storey.ShowNumber) {
            tempItems.push(item)
          }
        })
        StoreyItemsDto = tempItems
      }
      return StoreyItemsDto
    },
    // 楼层Item转换成通用goods数据
    _itemToGoods(item) {
      let goods = {}
      if (item.Goods) {
        goods = item.Goods
        goods.id = item.Goods.Id
        goods.cartNum = item.Goods.cartNum ? item.Goods.cartNum : 0
        goods.img = this._showProductPicture(
          item.ItemImage,
          item.Goods.Logo
        )
        goods.name = this._showProductTitle(
          item.Goods.SkuName,
          item.Goods.OperationName
        )
      } else {
        goods = item
        goods.id = item.Id
        goods.cartNum = item.cartNum ? item.cartNum : 0
        goods.img = item.Logo
        goods.name = this._showProductTitle(
          item.SkuName,
          item.OperationName
        )
      }
      return goods
    },
    _truncature(text, count) {
      if (!text || !count) {
        return
      }
      const len = this.getCharNumCount(text)
      const slen = text.length - len / 2
      return slen > count ? text.substring(0, count) + '...' : text
    },
    // 拼装跳转的url
    _getTurnUrl(linkType, linkValue) {
      if (linkType == 99 && linkValue.indexOf('vzan') > 0) {
        window.open(linkValue, '_blank')
        return
      }
      let page = ''

      const linkTypes = Object.keys(this.Enum_LinkType)
      if (linkValue && linkType == 12) {
        if (linkValue.split(',').length > 1 && linkValue) {
          return 'SearchPage'
        }
      }
      linkTypes.forEach((ly) => {
        if (this.Enum_LinkType[ly] == linkType) {
          page = this.Enum_LinkTypeCode[ly]
        }
      })

      console.log(linkType)

      return page
    },

    // 跳转页面
    _jump(url, value, target, name) {
      let params = {}
      switch (url) {
        case this.Enum_LinkTypeCode.Goods:
          if (typeof value === 'object') {
            params = {
              goodsId: value.id,
              detailType: value.detailType || '',
              configType: value.configType || '',
              ruleText: value.ruleText || '',
              IsOpenPreActivity: value.IsOpenPreActivity || false,
              activeIsBegin: value.activeIsBegin || false,
              conditionRelation: value.conditionRelation || ''
            }
          } else {
            params = {
              goodsId: value.toLowerCase()
            }
          }

          break
        case this.Enum_LinkTypeCode.Category:
          url = this.Enum_LinkTypeCode.SearchPage
          params = {
            category: value.toLowerCase()

          }
          break
          // case this.Enum_LinkTypeCode.ProductDetails:
          //   url = this.Enum_LinkTypeCode.ProductDetails
          //   params = {
          //     Id: value.toLowerCase()

        //   }
        //   break
        case this.Enum_LinkTypeCode.BrandMoreList:
          url = this.Enum_LinkTypeCode.BrandMoreList
          params = {
            goodsId: value
          }
          break
        case this.Enum_LinkTypeCode.HotSaleList:
          url = this.Enum_LinkTypeCode.HotSaleList

          // 3季节 4诊所 5药店
          params = {
            type: value == 1 ? value = 5 : value == 2 ? value = 4 : value = 3
          }
          break
        case this.Enum_LinkTypeCode.ActivitySeckillView:
          url = this.Enum_LinkTypeCode.ActivitySeckillView
          params = {
            id: value
          }
          break
        case this.Enum_LinkTypeCode.SearchPage:
          if (value.split(',').length > 0) {
            params = {
              ids: value
            }
          } else {
            params = {
              keyword: value
            }
          }

          break
        case this.Enum_LinkTypeCode.OperatingClassify:
          url = this.Enum_LinkTypeCode.SearchPage
          params = {
            category: value.toLowerCase(),
            name: name
          }
          break
        case this.Enum_LinkTypeCode.ActivityArea:
          url = this.Enum_LinkTypeCode.SearchPage
          params = {
            isHasActivity: !(value && value.ids),
            ids: value && value.ids ? value.ids : ''
          }
          break
        case this.Enum_LinkTypeCode.BrandProductList:
          url = this.Enum_LinkTypeCode.SearchPage
          try {
            params = JSON.parse(value)
          } catch {
            params = {
              brandId: null,
              name: ''
            }
          }
          break
        case this.Enum_LinkTypeCode.DtoProductList:
          url = this.Enum_LinkTypeCode.SearchPage
          console.log(url, value)
          try {
            params = JSON.parse(value)
          } catch {
            params = {
              category: null,
              keyword: '',
              isHasStock: false,
              isHasActivity: false,
              brandId: null,
              name: ''
            }
          }
          break
        case this.Enum_LinkTypeCode.StoreyProductList:
          params = value
          break
        default:
          if (typeof value === 'object') {
            params = {
              ...value
            }
          } else {
            if (value) {
              params = {
                id: value
              }
            }
          }
          break
      }
      if (url) {
        if (target == '_blank') {
          const routeUrl = this.$router.resolve({
            path: url,
            query: params
          })
          window.open(routeUrl.href, '_blank')
        } else {
          if (
            this.$router.history.current.name ==
            LinkTypeCode.SearchPage &&
            url == LinkTypeCode.SearchPage
          ) {
            this.$router.push({
              query: merge({}, params)
            })
            this.$router.go()
          } else {
            this.$router.push({ name: url, query: params })
          }
        }
      } else {
        this.$router.push({ name: LinkTypeCode.Home })
      }
    },
    // 截断字符串
    _truncature(text, count) {
      if (!text || !count) {
        return
      }
      const len = this.getCharNumCount(text)
      const slen = text.length - len / 2
      return slen > count ? text.substring(0, count) + '...' : text
    },
    // 显示商品图片
    _showProductPicture(image1, image2) {
      if (!image1 && !image2) {
        return ''
      }
      let image = image2
      if (image1) image = image1
      return image
    },
    // 楼层：商品展示标题  优先顺序 运营标题 > 商品名称
    _showProductTitle(SkuName, OperationName) {
      let title = SkuName
      if (OperationName) title = OperationName
      return title
    },
    // 显示商品价格 活动价 控销价
    _showProductPrice(price1, price2, isHideOrgialPrice) {
      let html = ''
      if (!price1 && !price2) {
        html = `<span class="goods-activity-price"><span style="margin-right:-2px">${this.lang.Basic.Price} </span>0<span>.00</span></span>`
      } else {
        if (
          price2 &&
          (!price1 || price1 >= price2 || isHideOrgialPrice)
        ) {
          const p2 = this._getPriceArray(price2)
          html = `<span class="goods-activity-price"><span style="margin-right:-2px">${this.lang.Basic.Price} </span>${p2[0]}<span>.${p2[1]}</span></span>`
        } else if (price2 && price1 && price1 <= price2) {
          const p1 = this._getPriceArray(price1)
          html = `<span class="goods-activity-price"><span>${this.lang.Basic.Price
          }</span>${p1[0]}<span>.${p1[1]
          }</span></span><s><span class="goods-original-price"><span>${this.lang.Goods.Price
          }${this.lang.Basic.Price} </span>${price2.toFixed(
            2
          )}</span></s>`
        } else if (price1) {
          const p1 = this._getPriceArray(price1)
          html = `<span class="goods-activity-price"><span style="margin-right:-2px">${this.lang.Basic.Price} </span>${p1[0]}<span>.${p1[1]}</span></span>`
        } else {
          const p2 = this._getPriceArray(price2)
          html = `<span class="goods-activity-price"><span style="margin-right:-2px">${this.lang.Basic.Price} </span>${p2[0]}<span>.${p2[1]}</span></span>`
        }
      }

      return html
    },
    // 分解价格数字
    _getPriceArray(price) {
      if (!price) {
        return [0, 0]
      }
      const strPrice = String(price)
      const array = strPrice.split('.')
      if (array.length == 1) {
        array.push('00')
      }
      //   console.log(array)
      return array
    },
    // 获取商品实际价格
    _getProductPrice(price1, price2) {
      if (!price1 && !price2) {
        return 0
      }
      let price = price2
      if (price1 && price1 <= price2) {
        price = price1
      }
      return price
    },
    // 显示毛利率
    _showProductProfit(price1, price2) {
      if (!Number(price1) || !Number(price2)) {
        return 0
      }
      const profit =
        ((Number(price1) - Number(price2)) / Number(price1)) * 100
      return Math.round(profit)
    },
    // 解析商品活动
    _analysisGoodsActivity(SalesPromotions) {
      const fullMoneyPresents = [] // 满赠
      const fullAmountPresents = [] // 买赠
      const fullReductions = [] // 满减
      const singleProducts = [] // 单品
      let firstTime = {
        Id: null,
        Time: null
      }
      // 是否最近的活动结束时间
      if (SalesPromotions) {
        SalesPromotions.forEach((sale) => {
          if (sale) {
            // 活动时间
            let salesTime = {}
            if (sale.SalesPromotionTimes) {
              sale.SalesPromotionTimes.forEach((time) => {
                if (time) {
                  if (
                    moment().isBetween(
                      moment(time.StartTime),
                      moment(time.EndTime, null, '[]')
                    )
                  ) {
                    salesTime = time
                    if (!moment(firstTime.Time).isValid()) {
                      firstTime = {
                        Id: sale.Id,
                        Time: time.EndTime
                      }
                    }
                    if (
                      moment(firstTime.Time).isAfter(
                        moment(time.EndTime)
                      )
                    ) {
                      firstTime = {
                        Id: sale.Id,
                        Time: time.EndTime
                      }
                    }
                  }
                }
              })
            }
            // 活动
            if (sale.SalesPromotionRules) {
              sale.SalesPromotionRules.forEach((rule) => {
                if (rule) {
                  if (rule.SalesPromotionRuleFullReductions) {
                    rule.SalesPromotionRuleFullReductions.forEach(
                      (reduction) => {
                        if (reduction) {
                          const data = {
                            Id: sale.Id,
                            PromotionName:
                              sale.PromotionName,
                            SalesTime: salesTime,
                            SalesRule: reduction
                          }
                          fullReductions.push(data)
                        }
                      }
                    )
                  }
                  if (rule.SalesPromotionRuleFullPresents) {
                    rule.SalesPromotionRuleFullPresents.forEach(
                      (present) => {
                        if (present) {
                          const data = {
                            Id: sale.Id,
                            PromotionName:
                              sale.PromotionName,
                            SalesTime: salesTime,
                            SalesRule: present
                          }
                          if (
                            present.PresentType ==
                            this.Enum_ReducationType
                              .Money
                          ) {
                            fullMoneyPresents.push(
                              data
                            )
                          }
                          if (
                            present.PresentType ==
                            this.Enum_ReducationType
                              .Amount
                          ) {
                            fullAmountPresents.push(
                              data
                            )
                          }
                        }
                      }
                    )
                  }
                  if (rule.SalesPromotionRuleSingleProducts) {
                    rule.SalesPromotionRuleSingleProducts.forEach(
                      (single) => {
                        if (single) {
                          const data = {
                            Id: sale.Id,
                            PromotionName:
                              sale.PromotionName,
                            SalesTime: salesTime,
                            SalesRule: single
                          }
                          singleProducts.push(data)
                        }
                      }
                    )
                  }
                }
              })
            }
          }
        })
      }
      if (
        fullMoneyPresents.length == 0 &&
        fullAmountPresents.length == 0 &&
        fullReductions.length == 0 &&
        singleProducts.length == 0
      ) {
        return null
      }

      const result = {
        MoneyPresents: fullMoneyPresents,
        AmountPresents: fullAmountPresents,
        Reductions: fullReductions,
        SingleProducts: singleProducts
      }

      const keys = Object.keys(result)
      keys.forEach((key) => {
        const activitys = result[key]
        activitys.forEach((item) => {
          if (item.Id == firstTime.Id) {
            result.FirstEnd = {
              Id: item.Id,
              Activity: item,
              EndTime: moment(firstTime.Time).format(
                this.Format_DateTime
              )
            }
          }
        })
      })
      //   console.log(result.FirstEnd)
      //   console.log('活动解析详情', result)
      return result
    },

    // 解析活动倒计时
    _analysisActivityDiffTime(time1, time2) {
      if (!time1 || !time2) {
        return
      }
      const unix = moment(time1).diff(moment(time2))
      const days = moment.duration(unix).asDays()
      const strDsys = String(days).split('.')
      const hours = (days - Number(strDsys[0])) * 24
      const strHours = String(hours).split('.')
      const minutes = (hours - Number(strHours[0])) * 60
      const strMinutes = String(minutes).split('.')
      const seconds = (minutes - Number(strMinutes[0])) * 60
      const time = `${strHours[0]}:${strMinutes[0]}:${Math.round(seconds)}`
      const result = [strDsys[0], time]
      return result
    },

    // 解析券包 领取/返券
    _analysisGoodsCoupons(CouponPackages) {
      const receiveCoupons = []
      const giftCoupons = []
      if (CouponPackages) {
        CouponPackages.forEach((couponPackage) => {
          if (
            couponPackage &&
            couponPackage.OutPackageIssueCouponDtos
          ) {
            couponPackage.OutPackageIssueCouponDtos.forEach(
              (couponIssue) => {
                if (
                  couponPackage.PackageGiftType ==
                  this.Enum_PackageGiftType.Receive
                ) {
                  receiveCoupons.push(
                    couponIssue.OutCouponIssueDto
                  )
                }
                if (
                  couponPackage.PackageGiftType ==
                  this.Enum_PackageGiftType.Gift
                ) {
                  giftCoupons.push(
                    couponIssue.OutCouponIssueDto
                  )
                }
              }
            )
          }
        })
      }
      let result = {
        ReceiveCoupons: receiveCoupons,
        GiftCoupons: giftCoupons
      }
      if (
        result.ReceiveCoupons.length == 0 &&
        result.GiftCoupons.length == 0
      ) {
        result = null
      }
      //   console.log('领取/返券券包解析详情', result)
      return result
    },

    // 解析券包 可用优惠券
    _analysisGoodsCanUseCoupons(CouponPackages) {
      const coupons = []
      if (CouponPackages) {
        CouponPackages.forEach((couponPackage) => {
          if (
            couponPackage &&
            couponPackage.OutPackageIssueCouponDtos
          ) {
            couponPackage.OutPackageIssueCouponDtos.forEach(
              (couponIssue) => {
                coupons.push(couponIssue.OutCouponIssueDto)
              }
            )
          }
        })
      }
      //   console.log('可用券包解析详情', coupons)
      return coupons
    },

    // 回退
    _goBack() {
      this._back()
    },
    // 确认弹框
    _confirm(title, msg, call, cancel) {
      this.$dialog
        .confirm({
          title: title,
          message: msg
        })
        .then(() => {
          call && call()
        })
        .catch(() => {
          cancel && cancel()
        })
    },

    // 截取日期时间格式中字段
    _setTimeStr(time, y) {
      if (!time) {
        return ''
      }
      const timeArr = time
        .replace(' ', ':')
        .replace(/:/g, '-')
        .split('-')
      if (y == 'date') { return timeArr[0] + '.' + timeArr[1] + '.' + timeArr[2] }
      if (y == 'time') { return timeArr[3] + ':' + timeArr[4] + ':' + timeArr[5] }
    },

    // 获取time的 时分秒数组
    _setTimerArr(time) {
      const timeArr = time.split(':')
      let result = null
      if (timeArr.length == 3) {
        result = []
        timeArr.forEach((time) => {
          time = time.length == 1 ? '0' + time : time
          result.push(time)
        })
      }
      return result
    },

    // 转换日期格式 业务端 新加 start
    _getFomatDate(valueTime, type) {
      if (valueTime) {
        const Y = valueTime.getFullYear()
        const M = valueTime.getMonth() + 1
        const D = valueTime.getDate()
        let curDay = ''
        if (type == 1) {
          curDay = Y + '-' + (M < 10 ? '0' + M : M) + '-' + '01'
        } else if (type == 2) {
          curDay = Y + '-' + '01' + '-' + '01'
        } else {
          curDay =
            Y +
            '-' +
            (M < 10 ? '0' + M : M) +
            '-' +
            (D < 10 ? '0' + D : D)
        }
        return curDay
      }
    },
    _getDateTime(screenParams) {
      let BeginTime = ''
      let EntTime = ''
      let dateText = ''
      if (
        screenParams ||
        (screenParams.timeTag &&
          screenParams.timeTag.name == '自定义时间')
      ) {
        BeginTime = screenParams.startTime
        EntTime = screenParams.endTime
        dateText = BeginTime + ' ~ ' + EntTime
      }
      if (screenParams.timeTag && screenParams.timeTag.name == '本年') {
        BeginTime = this._getFomatDate(new Date(), 2)
        EntTime = this._getFomatDate(new Date())
        dateText = '本年'
      }
      if (screenParams.timeTag && screenParams.timeTag.name == '本月') {
        BeginTime = this._getFomatDate(new Date(), 1)
        EntTime = this._getFomatDate(new Date())
        dateText = '本月'
      }
      if (screenParams.timeTag && screenParams.timeTag.name == '今天') {
        BeginTime = this._getFomatDate(new Date())
        EntTime = this._getFomatDate(new Date())
        dateText = '今天'
      }
      return {
        BeginTime,
        EntTime,
        dateText
      }
    },
    // 转换日期格式 业务端 新加end

    // 缩略图/大图
    _getPic(url, s) {
      const hysyzsIndex = url && url.indexOf('hysyzs')
      const uploadIndex = url && url.indexOf('upload')
      if (url && s && hysyzsIndex != -1 && uploadIndex != -1) {
        const sStr = url.substring(0, url.lastIndexOf('.'))
        const eStr = url.substring(url.lastIndexOf('.'), url.length)
        return sStr + '_s' + eStr
      } else {
        // console.log(url)
        return url
      }
    },

    // 传入毫秒的倒计时
    _timeMillisecondsInterval(
      milliseconds,
      timer,
      callBack,
      timerBack,
      onLoad
    ) {
      // 数字不满足两位的前端添加0
      let time = milliseconds
      const flag = milliseconds != 0
      const numStr = (num) => {
        return num.toString().length < 2 ? '0' + num.toString() : num
      }
      const fun = () => {
        let type = 1
        // 计算出时间
        const days = Math.floor(time / (24 * 3600 * 1000))
        const leave1 = time % (24 * 3600 * 1000) // 计算天数后剩余的毫秒数
        const hours = numStr(Math.floor(leave1 / (3600 * 1000)))
        const leave2 = leave1 % (3600 * 1000) // 计算小时数后剩余的毫秒数
        const minutes = numStr(Math.floor(leave2 / (60 * 1000)))
        const leave3 = leave2 % (60 * 1000) // 计算分钟数后剩余的毫秒数
        const seconds = numStr(Math.round(leave3 / 1000))
        time -= 1000
        if (time <= 0) {
          clearInterval(timer)
          type = 2
          if (flag) {
            if (onLoad) {
              onLoad()
            }
          }
        }
        callBack({
          type: type,
          d: days,
          h: hours,
          m: minutes,
          s: seconds
        })
      }
      // 先执行一次
      fun()
      // 每秒一次执行倒计时
      timer = setInterval(fun, 1000)
      // 为了清除定时器，返回定时器
      if (timerBack) {
        timerBack(timer)
      }
    },

    /**
         * 倒计时方法
         * @param {*} startTime 开始时间
         * @param {*} endTime   结束时间
         * @param {*} timer     传入变量
         * @param {*} callBack  回调函数
         * @param {*} timerBack 定时器回调
         */
    _timeIntervalReturn(startTime, endTime, timer, callBack, timerBack) {
      // 数字不满足两位的前端添加0
      const numStr = (num) => {
        return num.toString().length < 2 ? '0' + num.toString() : num
      }
      const fun = () => {
        // 1未开始，2进行中，3已结束
        let type = 1
        let date1, date2, date3
        // case1 当前时间小于等于开始时间
        // 未开始
        if (new Date().getTime() <= new Date(startTime).getTime()) {
          type = 1
          date1 = startTime
          date2 = new Date()
          date3 = new Date(date1).getTime() - date2.getTime() // 时间差的毫秒数
        }
        // 已结束
        // case2 当前时间大于等于结束时间
        if (new Date().getTime() >= new Date(endTime).getTime()) {
          type = 3
          clearInterval(timer)
        }
        // 进行中
        // case3 大于开始时间并小于结束时间
        if (
          new Date().getTime() < new Date(endTime).getTime() &&
          new Date().getTime() > new Date(startTime).getTime()
        ) {
          type = 2
          date1 = endTime
          date2 = new Date()
          date3 = new Date(date1).getTime() - date2.getTime() // 时间差的毫秒数
        }
        // 计算出时间
        const days = Math.floor(date3 / (24 * 3600 * 1000))
        const leave1 = date3 % (24 * 3600 * 1000) // 计算天数后剩余的毫秒数
        const hours = numStr(Math.floor(leave1 / (3600 * 1000)))
        const leave2 = leave1 % (3600 * 1000) // 计算小时数后剩余的毫秒数
        const minutes = numStr(Math.floor(leave2 / (60 * 1000)))
        const leave3 = leave2 % (60 * 1000) // 计算分钟数后剩余的毫秒数
        const seconds = numStr(Math.round(leave3 / 1000))
        callBack({
          type: type,
          d: days,
          h: hours,
          m: minutes,
          s: seconds
        })
      }
      // 先执行一次
      fun()
      // 每秒一次执行倒计时
      timer = setInterval(fun, 1000)
      // 为了清除定时器，返回定时器
      if (timerBack) {
        timerBack(timer)
      }
    },

    // 金额格式化
    _moneyFormat(num) {
      if (num && parseFloat(num) > 0) {
        num = (Math.round(num * 100) / 100).toString()
        const pArr = num.split('.')
        pArr[1] = pArr[1]
          ? `${(pArr[1] + '000').substring(0, 2)}`
          : '00'
        num = pArr.join('.')
        return num
      } else {
        return 0
      }
    },
    _moneyFormat4(num) {
      if (num && parseFloat(num) > 0) {
        num = (Math.round(num * 10000) / 10000).toString()
        const pArr = num.split('.')
        pArr[1] = pArr[1]
          ? `${(pArr[1] + '000').substring(0, 4)}`
          : '0000'
        num = pArr.join('.')
        return num
      } else {
        return '0.0000'
      }
    }
  },
  mounted() {
    this.$store.getters.servicePhone.then((w) => {
      this.lang.Basic.ServicePhone = w
    })
  }
}
